import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import * as TYPES from "./actionTypes";
import * as ACTIONS from "./actions";
import * as API from "helpers/backend_helper";
import { updateToken } from "helpers/api_helper";

import {errorMsg, successMsg} from "helpers/toastr";
import { loginSuccess } from "../login/actions";

 /**
      * Used for calling auth user api
      */

function* sendOtp({ payload: { user, callback } }) {
  try {
    const response = yield call(API.postsendOtp, user);

    callback && callback(response);
    if (response.status == "failure") {
      return yield put(ACTIONS.sendOtpFailed(response.message));
    }
    
    yield put(ACTIONS.sendOtpSuccessful(response));
  
  } catch (error) {
    yield put(ACTIONS.sendOtpFailed("Internal Server Error"));
  }
}

function* verifyOtpSaga({ payload: { user, callback } }) {
  try {
    const response = yield call(API.postVerifyOtp, user);

    callback && callback(response);
    if (response.status == "failure") {
      return yield put(ACTIONS.verifyOtpFailed(response.message));
    }
    
    yield put(ACTIONS.verifyOtpSuccessful(response));
    yield put(loginSuccess(response));
    localStorage.setItem("authUser", JSON.stringify(response));
    localStorage.setItem("token", response.data.Token)
    updateToken(response.data.Token);

  } catch (error) {
    yield put(ACTIONS.verifyOtpFailed("Internal Server Error"));
  }
}


export function* watchsendOtp() {
  yield takeEvery(TYPES.SEND_OTP, sendOtp);
  yield takeEvery(TYPES.VERIFY_OTP, verifyOtpSaga);

}

function* accountSaga() {
  yield all([fork(watchsendOtp)]);
}

export default accountSaga;
